export enum ApiMethod {
    POST = "POST",
    PATCH = "PATCH",
    PUT = "PUT",
    DELETE = "DELETE"
};

export enum AuthOperation {
    LOGIN = "POST_/auth/login",
    TOKEN = "POST_/auth/token",
    TOKEN_REFRESH = "POST_/auth/token-refresh",
    LOGOUT = "POST_/auth/logout",
    _2FA_EMAIL = "POST_/auth/2fa/email",
    _2FA_SMS = "POST_/auth/2fa/sms",
    _2FA_CHECK = "POST_/auth/2fa/check"
};

export type AuthOperationNameMapping = {
    [key in AuthOperation]: string;
};

export enum UsersOperation {
    VERIFY_RESET_CODE = "POST_/users/verify-reset-password",
    RESET_PASSWORD = "POST_/users/reset-password",
    UPDATE_PASSWORD = "PUT_/users/update-password",
    FORGOT_PASSWORD = "POST_/users/forgot-password",
    UPDATE_SELF_PROFILE = 'PATCH_/users/me',
    CREATE_USER = "POST_/users",
    UPDATE_USER = "PATCH_/users/{id}",
    DELETE_USER = "DELETE_/users/{id}",
    UPLAOD_USER_AVATAR = "PUT_/users/logo",
    SIGNUP_API_KEY = "POST_/users/me/api-consumer",
    DELETE_API_KEY = "DELETE_/users/me/api-consumer",
    GET_USER_QRCODE = "POST_/users/qrcode",
    RE_INVITE_EMAIL = "POST_/users/re-invite-email"
};

export type UsersOperationNameMapping = {
    [key in UsersOperation]: string;
};

export enum LicensesOperation {
    ASSIGN_LICENSE_TO_TENANT = "POST_/licenses",
    DELETE_LICENSE_FROM_TENANT = "DELETE_/licenses/amount",
    OPERATION_ON_MULTIPLE_LICENSE = "PATCH_/licenses",
    OPERATION_ON_SINGLE_LICENSE = "PATCH_/licenses/{id}",
};

export type LicensesOperationNameMapping = {
    [key in LicensesOperation]: string;
};

export enum DevicesOperation {
    DELETE_DEVICES = "DELETE_/devices",
    UPDATE_DEVICE = "PATCH_/devices/{id}",
    UPDATE_DEVICE_CONFIG = "PATCH_/devices/{id}/configuration",
    DELETE_DEVICE_SPEED_TEST_REPORT = "DELETE_/devices/{MAC}/speedtest",
    DISABLE_REMOTE_ACCESS = "DELETE_/devices/{MAC}/remote-access",
    UPDATE_DEVICE_INFO = "PATCH_/devices"
};

export type DevicesOperationNameMapping = {
    [key in DevicesOperation]: string;
};

export enum AlertConfigOperation {
    UPDATE_ALERT_POLICY = "PATCH_/alert-config/{id}",
    UPDATE_DEVICE_DATA_USAGE_SETTINGS = "POST_/alert-config/{id}/updateDataUsageSetting"
};

export type AlertConfigOperationNameMapping = {
    [key in AlertConfigOperation]: string;
};

export enum DeviceCmdOperation {
    SEND_COMMAND = "POST_/device-cmd",
    BACKUP_CONFIGURATION = "POST_/device-cmd/{MAC}/configuration/backup"
};

export type DeviceCmdOperationNameMapping = {
    [key in DeviceCmdOperation]: string;
};

export enum FilesOperation {
    GET_UPLOAD_URL = "POST_/files/upload-url",
    CREATE_FILE = "POST_/files",
    DELETE_FILE = "DELETE_/files/{id}",
    SHARE_FILE = "POST_/files/{id}/share",
    ACK_RECEIVED_FILE = "PATCH_/files/{id}/share/confirm-received",
    UPLOAD_PCI_INFO_IN_BULK = "PUT_/files/bulk-update-pci",
    UPLAOD_DEVICE_INFO_IN_BULK = "PUT_/files/bulk-update-device-info",
    UPLOAD_ACTIVATE_DEVICE_IN_BULK = "PUT_/files/bulk-activate-devices"
};

export type FilesOperationNameMapping = {
    [key in FilesOperation]: string;
};

export enum ApiConsumersOperation {
    DELETE_API_CONSUMER = "DELETE_/api-consumers/me",
    SIGNUP_API_KEY = "POST_/api-consumers/me"
};

export type ApiConsumersOperationNameMapping = {
    [key in ApiConsumersOperation]: string;
};

export enum DeviceAlarmOperation {
    SET_ALARM_READ = "PATCH_/device-alarm",
    SET_ALL_ALARM_READ = "PATCH_/device-alarm/readAll",
    GET_ALARM_COUNT = "POST_/device-alarm/date-range/{id}",
    GET_ALARM_COUNT_BY_DATE = "POST_/device-alarm/date-count/{id}"
};

export type DeviceAlarmOperationNameMapping = {
    [key in DeviceAlarmOperation]: string;
};

export enum DeviceReportsOperation {
    CREATE_REPORT = "POST_/device-reports",
    UPDATE_REPORT = "PATCH_/device-reports/{id}",
    DELETE_REPORT = "DELETE_/device-reports/{id}",
    EXPORT_REPORT = "POST_/device-reports/{id}/export"
};

export type DeviceReportsOperationNameMapping = {
    [key in DeviceReportsOperation]: string;
};

export enum GeoPciOperation {
    CREATE_GEO_PCI = "POST_/geo-pci",
    UPDATE_GEO_PCI = "PATCH_/geo-pci/{id}",
    DELETE_GEO_PCI = "DELETE_/geo-pci/{id}",
    DELETE_ALL_GEO_PCI = "DELETE_/geo-pci"
};

export type GeoPciOperationNameMapping = {
    [key in GeoPciOperation]: string;
};

export enum GroupsOperation {
    CREATE_GROUP_ROLE = "POST_/groups/{id}/roles",
    UPDATE_GROUP_ROLE = "PATCH_/groups/{id}/roles/{id}",
    DELETE_GROUP_ROLE = "DELETE_/groups/{id}/roles/{id}",
    CREATE_GROUP = "POST_/groups",
    UPDATE_GROUP = "PATCH_/groups/{id}",
    DELETE_GROUP = "DELETE_/groups/{id}",
    CREATE_USER_INTO_GROUP = "POST_/groups/{id}/users",
    UPDATE_USER_IN_GROUP = "PATCH_/groups/{id}/users/{id}",
    DELETE_USER_IN_GROUP = "DELETE_/groups/{id}/users/{id}"
};

export type GroupsOperationNameMapping = {
    [key in GroupsOperation]: string;
};

export enum DeviceGroupOperation {
    ASSIGN_GROUP_TO_DEVICE = "POST_/device-group/{id}/devices",
    UNASSIGN_GROUP_FROM_DEVICE = "DELETE_/device-group/devices"
};

export type DeviceGroupOperationNameMapping = {
    [key in DeviceGroupOperation]: string;
};

export enum ProfileTemplateOperation {
    CREATE_PROFILE_TEMPLATE = "POST_/profile-template",
    UPDATE_PROFILE_TEMPLATE = "PATCH_/profile-template/{id}",
    DELETE_PROFILE_TEMPLATE = "DELETE_/profile-template/{id}",
    PUSH_TEMPLATE_TO_DEVICE = "PATCH_/profile-template/groups/{id}/device"
};

export type ProfileTemplateOperationNameMapping = {
    [key in ProfileTemplateOperation]: string;
};

export enum RfStandardOperation {
    SAVE_RF_STANDARD = "POST_/rf-standard"
};

export type RfStandardOperationNameMapping = {
    [key in RfStandardOperation]: string;
};

export enum RolesOperation {
    CREATE_ROLE = "POST_/roles",
    UPDATE_ROLE = "PATCH_/roles/{id}",
    DELETE_ROLE = "DELETE_/roles/{id}"
};

export type RolesOperationNameMapping = {
    [key in RolesOperation]: string;
};

export enum SchedulesOperation {
    CREATE_SCHEDULE = "POST_/Schedules",
    UPDATE_SCHEDULE = "PUT_/Schedules",
    DELETE_SCHEDULE = "DELETE_/Schedules/{id}",
    RETRY_THE_TASK = "POST_/Schedules/retry",
    FORCE_START_THE_TASK = "POST_/Schedules/run-now"
};

export type SchedulesOperationNameMapping = {
    [key in SchedulesOperation]: string;
};

export enum TagsOperation {
    CREATE_TAG = "POST_/tags",
    DELETE_TAG = "DELETE_/tags/{id}",
    ASSIGN_TAG = "PATCH_/tags/multiDevice"
};

export type TagsOperationNameMapping = {
    [key in TagsOperation]: string;
};

export enum TenantsOperation {
    CREATE_TENANT = "POST_/tenants",
    UPDATE_TENANT = "PATCH_/tenants/{id}",
    DELETE_TENANT = "DELETE_/tenants/{id}",
    INVITE_USER_TO_TENANT = "POST_/tenants/{id}/users",
    UPDATE_USER_FROM_TENANT = "PATCH_/tenants/{id}/users/{id}",
    DELETE_USER_FROM_TENANT = "DELETE_/tenants/{id}/users/{id}",
    SET_TENANT_STATUS = "POST_/tenants/{id}/status/{actionStatus}",
    UPLOAD_TENANT_LOGO = "PUT_/tenants/{id}/logo",
    ACCESS_TENANT = "POST_/tenants/{id}/access",
    CREATE_ROLE_IN_TENANT = "POST_/tenants/{id}/roles",
    UPDATE_ROLE_FROM_TENANT = "PATCH_/tenants/{id}/roles/{id}",
    DELETE_ROLE_FROM_TENANT = "DELETE_/tenants/{id}/roles/{id}",

};

export type TenantsOperationNameMapping = {
    [key in TenantsOperation]: string;
};

export enum UsagesOperation {
    GET_BANDWIDTH_SUMMARY = "POST_/usages/bandwidth-summary",
    GET_BANDWIDTH_BY_DEVICE = "POST_/usages/{id}/bandwidth-usage",
    GET_BANDWIDTH_SUMMARY_BY_DEVICE = "POST_/usages/{id}/get-usage"
};

export type UsagesOperationNameMapping = {
    [key in UsagesOperation]: string;
};

export enum WebhookSettingsOperation {
    CREATE_WEBHOOK_PROFILE = "POST_/webhook-settings",
    UPDATE_WEBHOOK_PROFILE = "PATCH_/webhook-settings/{id}",
    TEST_WEBHOOK_PROFILE = "POST_/webhook-settings/webhooks"
};

export type WebhookSettingsOperationNameMapping = {
    [key in WebhookSettingsOperation]: string;
};